import React, { useState, useEffect } from "react";
import { styled } from "../../stitches.config";
import { h3, h4Strong, bodyLarge } from "../commonStyles/Fonts";

import Heading from "../atoms/Heading";
import SinglePodcast from "./SinglePodcast"

import { SimilarArticlesType } from "../../stores/ArticleStore";
import { createContext } from "vm";
import axios from "axios";
import { IPodcast } from "../types/Podcast";
import PodcastsList from "./PodcastsList";

interface IPodcastSerie {
    series: string;
    poster: any;
    episodes: IPodcast[];
};
interface ISimilarPodcastStore {
    [series: string]: IPodcastSerie;
};

const SIMILAT_PODCASTS_STORE: ISimilarPodcastStore = {};

const getSimilarPodcast = async (OID: number): Promise<IPodcastSerie> => {
    for (let series in SIMILAT_PODCASTS_STORE) {
        const episode = SIMILAT_PODCASTS_STORE[series].episodes.filter(e => e.OID == OID)[0];
        if (!episode) continue;

        return SIMILAT_PODCASTS_STORE[series];
    }

    const { data } = await axios.get(`${window.API_HOST}/pwa-podcast/${OID}`);
    const podcastData = data.podcast;

    SIMILAT_PODCASTS_STORE[podcastData.series] = {
        series: podcastData.series,
        poster: podcastData.episode_poster,
        episodes: podcastData.episodes
    }

    return SIMILAT_PODCASTS_STORE[podcastData.series];
};

interface Props {
    article: any;
}

const SimilarPodcasts: React.FC<Props> = ({ article }) => {

    const OID: number = article.OID || -1;
    const [similar, setSimilar] = useState<IPodcastSerie | null>(null);

    useEffect(() => {
        if (OID > 0)
            getSimilarPodcast(OID).then(e => setSimilar(e));
    }, [OID]);

    if (!similar || !similar.episodes) return <></>;

    if (!OID)
        return <></>;

    return (
        <div className="container">
            <StyledSimilarPodcasts>
                <PodcastsList
                    title={"Wszystkie odcinki"}
                    items={similar.episodes.map((e) => ({ ...e, poster: similar.poster }))}
                />
            </StyledSimilarPodcasts>
        </div>
    );
};

const StyledSimilarPodcasts = styled("div", {
    //padding: "32px 16px 0 16px",
    color: "$grayscale100",
    "@bp4": {
        //padding: "80px 0 0 84px",
        maxWidth: "840px",
    }
});

export default SimilarPodcasts;
